import { render, staticRenderFns } from "./ExpiredEmail.vue?vue&type=template&id=6b24dde2&"
import script from "./ExpiredEmail.vue?vue&type=script&lang=js&"
export * from "./ExpiredEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports